/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-redundant-roles */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { navigationPropType } from "@template/state/modules/navigation";
import {
  viewportPropType,
  LARGE_VIEWPORT
} from "@template/state/modules/layout";
import Spinner from "@template/components/Spinner";
import { isWindowDefined } from "@src/helpers/url";
import { getDesktopTemplate } from "@template/helpers/navigationTemplatesResolver";
import globalEventHandler, {
  events,
  keys,
  IE11Keys
} from "@template/globalEventHandler";
import { createIdAriaDescribedBy } from "@template/helpers/navigationAccessibility";

import styles from "./index.css";
import classnames from "classnames/bind";

const cx = classnames.bind(styles);

const inferTemplateComponent = item => {
  const { largeScreenTemplateId: id } = item;
  const TemplateComponent = getDesktopTemplate(id);

  return <TemplateComponent item={item} />;
};

class LargeSecondaryNavigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: props.item.items,
      marketplaceLinkCheck: false
    };
  }

  isVisible = () => {
    return (
      this.props.item.id === this.props.largeNavActiveItemId &&
      this.props.viewport === LARGE_VIEWPORT
    );
  };
  globalTrackingTimer = null;

  isLeftKey = event => event.key === keys.left;

  isShiftTabKey = event =>
    event.key === keys.tab && event.originalEvent.shiftKey;

  isEscKey = event =>
    event.key === keys.escape || event.key === IE11Keys.escape;

  ifFirstItemFocused = () =>
    document.activeElement.textContent ===
    this.props.item?.items[0]?.items[0]?.label;

  componentDidMount() {
    const {
      hasClickedInside,
      clearNavActiveItem,
      item: { id }
    } = this.props;

    this.globalClickListener = globalEventHandler.addListener(
      events.click,
      event => {
        if (this.isVisible() && !hasClickedInside(event)) {
          clearNavActiveItem();
        }
      }
    );

    this.globalKeyDownListener = globalEventHandler.addListener(
      events.keyDown,
      event => {
        if (this.isVisible() && this.isEscKey(event)) {
          clearNavActiveItem();
          document.querySelector(`button[data-id="${id}"]`).focus();
        } else if (
          this.isVisible() &&
          this.ifFirstItemFocused() &&
          (this.isShiftTabKey(event) || this.isLeftKey(event))
        ) {
          event.originalEvent.preventDefault();
          clearNavActiveItem();
          document.querySelector(`button[data-id="${id}"]`).focus();
        }
      }
    );
  }

  componentDidUpdate() {
    const {
      item,
      marketplaceVintageLinkDesktop = {},
      marketplaceVintageLinkMobile = {},
      testIsLoaded
    } = this.props;
    const { marketplaceLinkCheck } = this.state;
    const marketingLinkExists =
      this.state.items.reduce((acc, item) => {
        const marketingLink = item.items.find(
          item => item.id === "marketplaceLink"
        );
        marketingLink && acc.push(marketingLink);
        return acc;
      }, []).length > 0;

    if (
      item.items.length > 0 &&
      testIsLoaded &&
      !marketplaceLinkCheck &&
      !marketingLinkExists
    ) {
      const isClothingCategory = () =>
        item.labelPath[2] === "Categories" &&
        item.labelPath[3] === "Clothing" &&
        item.labelPath.length === 4;

      if (
        isClothingCategory() &&
        (marketplaceVintageLinkDesktop.enabled ||
          marketplaceVintageLinkMobile.enabled)
      ) {
        this.setState({
          items: this.addMarketplaceLink(item.items),
          marketplaceLinkCheck: true
        });
      } else {
        this.setState({
          items: item.items,
          marketplaceLinkCheck: true
        });
      }
    }
  }

  componentWillUnmount() {
    this.globalClickListener && this.globalClickListener.remove();
    this.globalKeyDownListener && this.globalKeyDownListener.remove();
  }

  addMarketplaceLink = items => {
    const {
      marketplaceVintageLinkDesktop: {
        enabled: marketplaceVintageLinkDesktopEnabled
      }
    } = this.props;

    const shopByProductIndex = items.findIndex(
      item => item.label.toLowerCase() === "shop by product"
    );

    if (shopByProductIndex > -1) {
      const variant = marketplaceVintageLinkDesktopEnabled
        ? "EMF95_v2"
        : "EMF137_v2";
      const gender = items[shopByProductIndex].gender;
      const fullTextGender = gender === "WW" ? "women" : "men";
      const marketplaceLink = {
        alias: null,
        id: `marketplaceLink`,
        items: [],
        excludes: [],
        label: "Vintage - Marketplace.ASOS.com",
        type: "link",
        link: `https://marketplace.asos.com/${fullTextGender}/just-in?tab=boutique&f:condition=12109&ctaref=mktp|${fullTextGender}|nav|justin|vintage&nlid=${variant}_${gender}NewVariant`,
        linkType: "external",
        webLargePriority: 0,
        largeScreenStyleType: "premium",
        smallAndMediumStyleType: "premium"
      };

      const updatedItems = [...items];

      updatedItems[shopByProductIndex].items = [
        ...updatedItems[shopByProductIndex].items,
        marketplaceLink
      ];

      return updatedItems;
    }
    return items;
  };

  renderHeading = item => {
    if (!item || (item && !item.label)) return null;
    const id = createIdAriaDescribedBy(item.label);

    return (
      <h2 id={id} className={styles.columnHeader}>
        <span>{item.label}</span>
      </h2>
    );
  };

  renderContainer = item => {
    const { largeScreenStyleType, largeScreenColumnSpan } = item;
    const showHeading = largeScreenStyleType !== "noTitle";

    return (
      <li
        key={item.id}
        className={cx(
          styles.column,
          styles[`colspan-${largeScreenColumnSpan || 1}`]
        )}
      >
        {showHeading && this.renderHeading(item)}
        {inferTemplateComponent(item)}
      </li>
    );
  };

  render() {
    const { item, clearNavActiveItem } = this.props;
    const { items } = this.state;
    const classes = cx(styles.container, {
      [styles.visible]: this.isVisible()
    });

    const hasNoItems = !item.items.length;

    //The window type checking is a work around to
    //make the classes match server and client side
    const flyoutClasses = cx(styles.flyout, {
      [styles.isLoading]: hasNoItems || !isWindowDefined()
    });

    return (
      <div
        className={classes}
        data-testid="secondarynav-container"
        ref={c => (this.container = c)}
      >
        <div
          className={styles.backdrop}
          onClick={clearNavActiveItem}
          onMouseMove={clearNavActiveItem}
          aria-hidden="true"
          data-testid="backdrop"
        />
        <div className={styles.flyoutContainer}>
          <ul
            role="list"
            className={flyoutClasses}
            data-id={item.id}
            data-testid="secondarynav-flyout"
          >
            {hasNoItems ? (
              <Spinner size="x-large" />
            ) : (
              items.map(this.renderContainer)
            )}
          </ul>
        </div>
      </div>
    );
  }

  static propTypes = {
    item: navigationPropType.isRequired,
    largeNavActiveItemId: PropTypes.string,
    setNavActiveItem: PropTypes.func.isRequired,
    clearNavActiveItem: PropTypes.func.isRequired,
    buttonElement: PropTypes.object,
    viewport: viewportPropType.isRequired,
    hasClickedInside: PropTypes.func.isRequired,
    marketplaceVintageLinkDesktop: PropTypes.oneOfType([
      PropTypes.shape({
        enabled: PropTypes.bool
      }),
      PropTypes.bool
    ]),
    marketplaceVintageLinkMobile: PropTypes.oneOfType([
      PropTypes.shape({
        enabled: PropTypes.bool
      }),
      PropTypes.bool
    ]),
    testIsLoaded: PropTypes.bool
  };
}

export default LargeSecondaryNavigation;
